<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-format-list-checkbox"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="12" class="content_warranties_center rounded-lg">
          <v-row class="mx-3">
            <v-col cols="6">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Tên trung tâm bảo hành"
                v-model="warranties_center.name"
                placeholder="Nhập tên trung tâm bảo hành"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Slug"
                v-model="warranties_center.slug"
                placeholder="Nhập slug"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-select
                background-color="#EDF2F7"
                filled
                :items="areas"
                item-text="name"
                item-value="id"
                v-model="warranties_center.area_id"
                label="Chọn khu vực"
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                background-color="#EDF2F7"
                filled
                :items="provinces"
                item-text="name"
                item-value="id"
                v-model="warranties_center.province_id"
                label="Chọn tỉnh thành"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                background-color="#EDF2F7"
                filled
                :items="districts"
                item-text="name"
                item-value="id"
                v-model="warranties_center.district_id"
                label="Chọn quận huyện"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                background-color="#EDF2F7"
                filled
                :items="wards"
                item-text="name"
                item-value="id"
                v-model="warranties_center.ward_id"
                label="Chọn phường xã"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Địa chỉ"
                v-model="warranties_center.address"
                placeholder="Nhập địa chỉ"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Tọa độ X (địa chỉ)"
                v-model="warranties_center.lat"
                placeholder="Nhập tọa độ X"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Tọa độ Y (địa chỉ)"
                v-model="warranties_center.long"
                placeholder="Nhập tọa độ Y"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Thời gian bắt đầu làm việc"
                v-model="warranties_center.start_work_time"
                placeholder="Nhập thời gian kết thúc làm việc"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Thời gian kết thúc làm việc"
                v-model="warranties_center.end_work_time"
                placeholder="Nhập thời gian kết thúc làm việc"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Tel"
                v-model="warranties_center.phone"
                placeholder="Nhập tel"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Hotline"
                v-model="warranties_center.hotline"
                placeholder="Nhập hotline"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                background-color="#EDF2F7"
                filled
                :items="supports"
                item-text="fullname"
                item-value="id"
                v-model="warranties_center.support_id"
                label="Chọn cửa hàng trưởng"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Độ ưu tiên"
                v-model="warranties_center.order"
                placeholder="Độ ưu tiên"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                background-color="#EDF2F7"
                filled
                :items="brands"
                item-text="name"
                item-value="id"
                label="Chọn brand"
                v-model="warranties_center.brand_ids"
                multiple
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-file-input
                  multiple
                  label="Ảnh"
                  placeholder="Tải ảnh lên"
                  prepend-icon="mdi-camera"
                  @change="uploadImage"
              ></v-file-input>
            </v-col>
              <v-col cols="3" v-for="(img,index) in list_imgs" :key="img.id">
                <v-row >
                  <v-col cols="12" class="d-flex justify-center">
                    <v-img
                        height="150"
                        width="150"
                        :src="img.url"

                    ></v-img>
                  </v-col>
                  <v-col cols="6" class="d-flex justify-start ">


                  </v-col>

                  <v-col cols="6" class="d-flex justify-end">
                    <v-btn
                        @click="clearImg(index)"
                        x-small
                        outlined
                        fab
                        color="red"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="SEO title"
                  v-model="warranties_center.meta_title"
                  placeholder="Nhập SEO title"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="SEO description"
                  v-model="warranties_center.meta_description"
                  placeholder="Nhập SEO description"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="content_warranties_center rounded-lg mt-3">
          <v-row class="mx-3">
            <v-col cols="12">
              <span
                >Giới thiệu trung tâm bảo hành
                <v-btn color="primary" icon @click="addBlock">
                  <v-icon>mdi-plus-box</v-icon>
                </v-btn>
              </span>
            </v-col>
          </v-row>
          <v-row
            class="mx-3"
            v-for="(intro, index) in warranties_center.list_warranties_center_description"
            :key="index"
          >
            <v-col cols="6">
              <v-file-input
                label="Ảnh"
                placeholder="Tải ảnh lên"
                prepend-icon="mdi-camera"
                @change.self="fileSelected($event, index)"
              ></v-file-input>
              <v-img
                :src="intro.url"
                height="200px"
                width="200px"
                contain
              ></v-img>
            </v-col>
            <v-col cols="6">
              <div class="d-flex justify-end">
                <v-btn
                  class="ma-2"
                  outlined
                  large
                  color="indigo"
                  @click="clearDesciption(index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
              <v-textarea
                class="content-textarea"
                background-color="#EDF2F7"
                filled
                v-model="intro.description"
                label="Mô tả"
                placeholder="Nhập tên mô tả"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn color="primary" width="180" @click="save_category()">
            Lưu
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { UPLOAD_WARRANTIES_CENTER_IMAGE, SAVE_WARRANTIES_CENTER } from "@/store/modules/warranties_center";
import { GET_LIST_SUPPORT } from "@/store/modules/support";
import {
  GET_LIST_AREAS,
  GET_LIST_DISTRICTS,
  GET_LIST_PROVINCES,
  GET_LIST_WARDS,
} from "@/store/modules/residence";
import { GET_LIST_BRAND } from "@/store/modules/brand";
// import {UPLOAD} from '@/store/modules/upload'
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      list_imgs:[],
      src: "",
      image: {},
      hasImage: false,
      selectedFile: null,
      warranties_center: {
        order: 0,
        name: "",
        area_id: null,
        province_id: null,
        district_id: null,
        ward_id: null,
        description: "",
        address: "",
        slug: "",
        lat: "",
        long: "",
        phone: "",
        hotline: "",
        support_id: null,
        start_work_time: "",
        end_work_time: "",
        brand_ids :[],
        list_warranties_center_description: [],
        list_media: [],
        meta_title: '',
        meta_description: ''
      },
      page: "Quản lý trung tâm bảo hành",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý trung tâm bảo hành",
          disabled: true,
        },
        {
          text: "Thêm trung tâm bảo hành",
          disabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      areas: "areas",
      provinces: "provinces",
      districts: "districts",
      wards: "wards",
      supports: "supports",
      brands: "brands",
    }),
  },
  watch: {
    "warranties_center.area_id": function (val) {
      this.$store.dispatch(`${GET_LIST_PROVINCES}`, val);
    },
    "warranties_center.province_id": function (val) {
      this.$store.dispatch(`${GET_LIST_DISTRICTS}`, val);
    },
    "warranties_center.district_id": function (val) {
      this.$store.dispatch(`${GET_LIST_WARDS}`, val);
    },
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_AREAS}`);
    await this.$store.dispatch(`${GET_LIST_SUPPORT}`);
       await this.$store.dispatch(`${GET_LIST_BRAND}`);
  },
  methods: {
    uploadImage(event){
      const _this = this;
      if (!event) {
        this.list_media = []
      } else {
        // this.production.list_media = []
        let formData = new FormData();

        event.forEach(element => {
          formData.append("upload", element);
          formData.append("type", "warranties_center");
          _this.$store.dispatch(`${UPLOAD_WARRANTIES_CENTER_IMAGE}`,formData).then((data) => {
            data.data.data.forEach(el => {
              let data_media = {
                id: el.media_id,
                url: el.url,
              }
              _this.list_imgs.push({
                id: el.media_id,
                url: el.url,
              })
              _this.warranties_center.list_media.push(data_media);
            })
          })
        })
      }
    },
    clearImg(index){
      this.list_imgs.splice(index, 1)
      this.warranties_center.list_media.splice(index, 1)
      this.$forceUpdate()
    },
    clearDesciption(index) {
      this.warranties_center.list_warranties_center_description.splice(index, 1);
      this.$forceUpdate();
    },
    addBlock() {
      this.warranties_center.list_warranties_center_description.push({
        url: "",
        description: "",
      });
      this.$forceUpdate();
    },
    clearBlock(i, index) {
      this.warranties_center.list_warranties_center_description.splice(index, 1);
      this.$forceUpdate();
    },
    fileSelected: function (event, index) {
      if (!event) {
        this.src = "";
      }
      this.image = event;
      this.src = URL.createObjectURL(this.image);
      if (this.image) {
        this.hasImage = !this.hasImage;
      }
      let formData = new FormData();
      formData.append("upload", this.image);
      formData.append("type", "warranties_center");
      this.$store
        .dispatch(`${UPLOAD_WARRANTIES_CENTER_IMAGE}`, formData)
        .then((data) => {
          if (data && data.data && data.data.data) {
            data.data.data.forEach((element) => {
              let intro = this.warranties_center.list_warranties_center_description.find(
                (element, i) => i == index
              );
              intro.url = element.url;
            });
          }
        });
    },
    async save_category() {
      let data_warranties_center = {
        name: this.warranties_center.name,
        ward_id: this.warranties_center.ward_id,
        address: this.warranties_center.address,
        slug: this.warranties_center.slug,
        lat: this.warranties_center.lat,
        long: this.warranties_center.long,
        phone: this.warranties_center.phone,
        hotline: this.warranties_center.hotline,
        support_id: this.warranties_center.support_id,
        brand_ids : JSON.stringify(this.warranties_center.brand_ids),
        start_work_time: this.warranties_center.start_work_time,
        end_work_time: this.warranties_center.end_work_time,
        list_warranties_center_description: JSON.stringify(
          this.warranties_center.list_warranties_center_description
        ),
        list_media: JSON.stringify(
            this.warranties_center.list_media
        ),
        meta_title: this.warranties_center.meta_title,
        meta_description: this.warranties_center.meta_description,
      };
      await this.$store
        .dispatch(`${SAVE_WARRANTIES_CENTER}`, data_warranties_center)
        .then((data) => {
          if (data.data.status == 1) {
            this.$toasted.success('Cập nhật thành công!', {
              duration:1000,
              position:'top-center'
            })
            this.$router.push("/warranties_center");
          } else {
            alert(data.data.errors);
          }
        });
    },
  },
};
</script>
<style lang="scss">
.content_warranties_center {
  background: #ffffff !important;
  .content-textarea .v-input__control {
    height: 165px !important;
  }
}
</style>